import React from 'react';

const ConfirmMailContent = ({ email }) => {
  return (
    <>
      <h5 className="mb-2">Confirm your email</h5>
      <p className="mb-0">An email has been sent to {email || 'your email'}. Please follow the link to verify.</p>
    </>
  );
};

export default ConfirmMailContent;
